// extracted by mini-css-extract-plugin
module.exports = {"text":"headlineSkins-xlargeOnWide-text-be94d677"};